/** @jsx jsx */
import { jsx } from '@emotion/core';
import Axios from 'axios';
import { Container } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import DotComponent from '../../ui/DotComponent';

import * as styles from './index.styles';
import Slider from './Slider';
import Spacer from '../../ui/Spacer';

const API_URL = 'https://api.reviews.co.uk/';
const STORE_ID = 'regus-offices';
const PER_PAGE = 12;
const MIN_RATING = 3.8;

class ReviewIO extends SafePureComponent {
  state = { reviews: [], average_rating: 0, total_reviews: 0, windowWidth: 0 };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    var reviewsRes = await Axios.get(
      API_URL +
        `merchant/reviews?store=${STORE_ID}&per_page=${PER_PAGE}&min_rating=${MIN_RATING}`,
    );
    if (reviewsRes.data.reviews) {
      this.setState({
        total_reviews: reviewsRes.data.stats.total_reviews,
        average_rating: reviewsRes.data.stats.average_rating,
        reviews: reviewsRes.data.reviews,
      });
    }
  };

  safeRender() {
    const { reviews, total_reviews, average_rating } = this.state;
    if (reviews.length < 4) {
      return null;
    }

    return (
      <Spacer
        customCss={[styles.hiddenspace]}
        paddingCss={styles.containerPaddingCss}
      >
        <div className="hiddenextraspace">
          <Container css={[styles.reviewsWidgetHolder]}>
            <div className="heading_sec">
              <h2>
                What our customers say
                <DotComponent />
              </h2>

              <div className="review_top_right">
                <div className="heighlight_reviews">
                  {average_rating && (
                    <div>
                      <span>{average_rating}</span> Average
                    </div>
                  )}

                  {total_reviews && (
                    <div>
                      <span>{total_reviews}</span> Reviews
                    </div>
                  )}
                </div>
                <img
                  src="https://assets.reviews.io/img/all-global-assets/logo/reviewsio-logo.svg"
                  alt="Reviews.io"
                />
              </div>
            </div>
            <div>
              {reviews.length > 0 ? (
                <Slider reviews={reviews} />
              ) : (
                <div>Please wait...</div>
              )}
            </div>
          </Container>
        </div>
      </Spacer>
    );
  }
}
export default ReviewIO;
